import { PrimaryCell, PrimaryCellProps, TableData } from '@revolut-internal/ui-kit-table'

type TypedPrimaryCellProps<Data extends TableData> = Omit<
  PrimaryCellProps<Data>,
  'cell'
> & {
  cell: PrimaryCellProps<Data>['cell']
}

export const TypedPrimaryCell = <Data extends TableData>({
  cell,
  ...props
}: TypedPrimaryCellProps<Data>) => <PrimaryCell cell={cell} {...props} />
